// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, setServiceProperties, getServiceProperties } from "./operations.js";
export type {
  TableServicesListOptionalParams,
  TableServicesSetServicePropertiesOptionalParams,
  TableServicesGetServicePropertiesOptionalParams,
} from "./options.js";
